var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Validate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.48 21.78L28.34 59.69 12.49 43.84 15.32 41l12.82 12.83 30.33-34.69 3.01 2.64z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Validate.9138905d.svg";
export { SvgJ2Validate as ReactComponent };